export const filterContentById = (content, id) => content.filter(item => { var _a; return ((_a = item.sys.contentType) === null || _a === void 0 ? void 0 : _a.sys.id) === id; });
// TODO - clean up types
// https://instant.atlassian.net/browse/INST-6566
export const filterConfigs = (configs, contentTypeId) => configs.flatMap(({ fields }) => { var _a; return (fields.configurationType === contentTypeId ? ((_a = fields.configuration) !== null && _a !== void 0 ? _a : []) : []); });
/*
    Convert keys to normalized format.
    Contentful has dropdowns to select values - they aren't configured as key value pairs
    So it's just regular values - Which are written in readable formats - e.g Blog Page
    So we need to convert them to camelCase keys.
*/
export const normalizeKeys = (key) => {
    if (!key)
        return "";
    return key
        .toLowerCase()
        .replace(/[-_\s]+(.)?/g, (_, char) => (char ? char.toUpperCase() : ""))
        .replace(/^[A-Z]/, char => char.toLowerCase());
};
